import {
  ENDPOINT_FARMER_ACTION_INSPECT,
  ENDPOINT_PROJECT_CONTOURS,
  ENDPOINT_PROJECT_CONTOURS_ACTIONS_BY_MONTH,
  ENDPOINT_PROJECT_DETAILS,
  ENDPOINT_PROJECTS_MASTER_APPRENTICES,
  ENDPOINT_PROJECTS_POST,
} from '@/common/constants';
import { HttpApi } from '@/common/http';
import { IActionInspectData } from '@/features/stewardship/models';
import { create } from 'zustand';
import {
  AgroEventsProjectContoursResponse,
  AgroEventsResponse,
  IAgroTechnicalEventById,
  TAgroTechnicalEvents,
} from '../models/IAgroTechnicalEvents';
import { AgroTechnicalEvent } from '../models/agro-events.model';

const httpApi = new HttpApi();

const useAgroTechnicalEventsStore = create<TAgroTechnicalEvents>(
  (set, get) => ({
    agroTechnicalEventsListLoading: false,
    agroTechnicalEventsList: [],
    agroEvents: [],
    agroEventsLoading: false,
    agroTechnicalEventById: {} as IAgroTechnicalEventById,
    agroTechnicalEventProjectContours: [],
    actionInspectData: null,
    actionInspectLoading: false,
    agroTechnicalEventByIdLoading: false,
    agroTechnicalEventsProjectLoading: false,
    agroTechnicalEventProjectContoursLoading: false,
    fetchAgroTechnicalEvents: async (
      district_id: string,
      master_id: string,
    ) => {
      set({ agroTechnicalEventsListLoading: true });
      const res = await httpApi.get<AgroEventsResponse[]>(
        `${ENDPOINT_PROJECTS_MASTER_APPRENTICES}`,
        {
          district_id,
          master_id,
        },
      );

      set({
        agroTechnicalEventsList: res,
      });

      setTimeout(() => {
        set({ agroTechnicalEventsListLoading: false });
      }, 300);
    },
    fetchAgroTechnicalEventById: async (params: { id: string }) => {
      set({ agroTechnicalEventByIdLoading: true });
      const res = await httpApi.get<IAgroTechnicalEventById>(
        `${ENDPOINT_PROJECT_DETAILS}${params.id}`,
        {},
      );
      set({
        agroTechnicalEventById: res,
      });

      setTimeout(() => {
        set({ agroTechnicalEventByIdLoading: false });
      }, 300);
    },
    fetchAgroTechnicalEventProjectContours: async (params: {
      id: string;
      month: string;
    }) => {
      set({
        agroTechnicalEventProjectContoursLoading: true,
      });
      const res = await httpApi.get<AgroEventsProjectContoursResponse[]>(
        `${ENDPOINT_PROJECT_CONTOURS}/${params?.id}`,
        {
          month: params?.month,
        },
      );
      set({
        agroTechnicalEventProjectContours: res,
      });
      setTimeout(() => {
        set({ agroTechnicalEventProjectContoursLoading: false });
      }, 300);
    },
    fetchAgroEvents: async (params: {
      month: string;
      contour_id: string;
      project_id: string;
      crop_id?: string | number;
    }) => {
      set({ agroEventsLoading: true });
      const res = await httpApi.get<AgroTechnicalEvent[]>(
        ENDPOINT_PROJECT_CONTOURS_ACTIONS_BY_MONTH,
        params,
      );
      set({
        agroEvents: res,
        // agroEventsLoading: false,
      });
      setTimeout(() => {
        set({ agroEventsLoading: false });
      }, 300);
    },
    fetchAgroTechnicalEventsProjects: async (params: any) => {
      set({ agroTechnicalEventsProjectLoading: true });
      const res = await httpApi.post(ENDPOINT_PROJECTS_POST, params);
      setTimeout(() => {
        set({ agroTechnicalEventsProjectLoading: false });
      }, 300);
    },
    fetchActionInspect: async (params: {
      farmer_action_by_project_id: string;
      farmer_action_by_project_contour_id: string | null;
      contour_id: string;
    }) => {
      set({ actionInspectLoading: true });
      try {
        const queryParams: Record<string, string> = {};
        if (params.farmer_action_by_project_contour_id) {
          queryParams.farmer_action_by_project_contour_id =
            params.farmer_action_by_project_contour_id;
        }
        if (params.contour_id) {
          queryParams.contour_id = params.contour_id;
        }

        const res = await httpApi.get<IActionInspectData>(
          `${ENDPOINT_FARMER_ACTION_INSPECT}/${params.farmer_action_by_project_id}`,
          queryParams,
        );
        set({ actionInspectData: res || null });
      } catch (error) {
        console.error('Error fetching action inspect data:', error);
        set({ actionInspectData: null });
      } finally {
        setTimeout(() => {
          set({ actionInspectLoading: false });
        }, 300);
      }
    },
    clearActionInspectData: () => {
      set({ actionInspectData: null, actionInspectLoading: false });
    },
  }),
);

export default useAgroTechnicalEventsStore;
